import React, { FC } from 'react';

type PropsT = {
    fill?: string;
    style: any;
    onClick?: () => void;
};

const DragIcon: FC<PropsT> = ({ fill = 'currentColor', style, ...rest }) => (
    <svg {...rest} style={style} width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 0 2 0C0.895431 0 0 0.895431 0 2C0 3.10457 0.895431 4 2 4ZM12 4C13.1046 4 14 3.10457 14 2C14 0.895431 13.1046 0 12 0C10.8954 0 10 0.895431 10 2C10 3.10457 10.8954 4 12 4ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM14 22C14 23.1046 13.1046 24 12 24C10.8954 24 10 23.1046 10 22C10 20.8954 10.8954 20 12 20C13.1046 20 14 20.8954 14 22ZM4 12C4 13.1046 3.10457 14 2 14C0.895431 14 0 13.1046 0 12C0 10.8954 0.895431 10 2 10C3.10457 10 4 10.8954 4 12ZM2 24C3.10457 24 4 23.1046 4 22C4 20.8954 3.10457 20 2 20C0.895431 20 0 20.8954 0 22C0 23.1046 0.895431 24 2 24Z" fill={fill || "#909090"}/>
</svg>
);

export default DragIcon;import React, { FC } from 'react';

type PropsT = {
    fill?: string;
    style: any;
    onClick?: () => void;
};

const DragIcon: FC<PropsT> = ({ fill = 'currentColor', style, ...rest }) => (
    <svg {...rest} style={style} width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M2 4C3.10457 4 4 3.10457 4 2C4 0.895431 3.10457 0 2 0C0.895431 0 0 0.895431 0 2C0 3.10457 0.895431 4 2 4ZM12 4C13.1046 4 14 3.10457 14 2C14 0.895431 13.1046 0 12 0C10.8954 0 10 0.895431 10 2C10 3.10457 10.8954 4 12 4ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM14 22C14 23.1046 13.1046 24 12 24C10.8954 24 10 23.1046 10 22C10 20.8954 10.8954 20 12 20C13.1046 20 14 20.8954 14 22ZM4 12C4 13.1046 3.10457 14 2 14C0.895431 14 0 13.1046 0 12C0 10.8954 0.895431 10 2 10C3.10457 10 4 10.8954 4 12ZM2 24C3.10457 24 4 23.1046 4 22C4 20.8954 3.10457 20 2 20C0.895431 20 0 20.8954 0 22C0 23.1046 0.895431 24 2 24Z" fill={fill || "#909090"}/>
</svg>
);

export default DragIcon;